import {Component, effect, inject, input, signal} from '@angular/core';
import {GatewaySvgComponent} from "src/app/presentation/common/icons/gateway-svg/gateway-svg.component";
import {LoRaGateway, SynchronizationStatus} from "src/app/infrastructure/moovement-api/models/asset";
import {toGatewayColorClass, toGatewayMessage} from 'src/app/domain/devices/gateway/gateway';
import {Router} from '@angular/router';
import {GatewayStore} from 'src/app/domain/devices/gateway/gateway.store';
import {GatewayStatusStore} from 'src/app/domain/devices/gateway/gateway-status.store';

@Component({
  selector: 'app-gateway-button',
  imports: [
    GatewaySvgComponent
  ],
  templateUrl: './gateway-button.component.html',
  styleUrl: './gateway-button.component.css'
})
export class GatewayButtonComponent {

  id = input.required<string>();

  SynchronizationStatus = SynchronizationStatus;
  gateway = signal<LoRaGateway | undefined>(undefined);
  status = signal<string | undefined>(undefined);
  statusMessage = signal('Last seen: ?');
  statusMessageColorClass = signal('color-danger');

  private gatewayStore = inject(GatewayStore);
  private gatewayStatusStore = inject(GatewayStatusStore);
  private router = inject(Router);

  constructor() {
    effect(() => {
      this.gateway.set(this.gatewayStore.entityMap()[this.id()]);
    });

    effect(() => {
      const status = this.gatewayStatusStore.entityMap()[this.id()];
      if (!status) return;

      this.status.set(status.normalisedValue);
      this.statusMessage.set(toGatewayMessage(status.normalisedValue, status.instant));
      this.statusMessageColorClass.set(toGatewayColorClass(status.normalisedValue));
    });
  }

  focus() {
    this.router.navigate(['/main/gateway-details', this.id()]);
  }
}
